import { CommonError } from '../../types';
import { OrderHistoryActions } from './actions';
import { FETCH_ORDER_HISTORY_FAILURE, FETCH_ORDER_HISTORY_REQUEST, FETCH_ORDER_HISTORY_SUCCESS, FETCH_ORDER_MATCH_HISTORY_FAILURE, FETCH_ORDER_MATCH_HISTORY_REQUEST, FETCH_ORDER_MATCH_HISTORY_SUCCESS } from './constants';
import { OrderHistoryData, OrderMatchHistoryData } from './types';

export interface StockOrderHistoryState {
    orderHistoryDatas: OrderHistoryData[];
    orderMatchHistoryDatas: OrderMatchHistoryData[];
    loading: boolean;
    orderMatchLoading: boolean;
    error: CommonError | null;
}
const initialState = {
    loading: false,
    orderMatchLoading: false,
    orderHistoryDatas: [],
    orderMatchHistoryDatas: [],
    error: null,
};
export const StockOrderHistoryReducer = (state = initialState, action: OrderHistoryActions): StockOrderHistoryState => {
    switch (action.type) {
        case FETCH_ORDER_HISTORY_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_ORDER_HISTORY_SUCCESS: {
            return { ...state, loading: false, orderHistoryDatas: action.payload };
        }
        case FETCH_ORDER_HISTORY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case FETCH_ORDER_MATCH_HISTORY_REQUEST:
            return { ...state, orderMatchLoading: true, error: null };
        case FETCH_ORDER_MATCH_HISTORY_SUCCESS: {
            return { ...state, orderMatchLoading: false, orderMatchHistoryDatas: action.payload };
        }
        case FETCH_ORDER_MATCH_HISTORY_FAILURE:
            return { ...state, orderMatchLoading: false, error: action.payload };
        default:
            return state;
    }
};
